import React from 'react';
import { cn } from '../../../lib/cn';

/**
 * QtyStepper, the minus and plus quantity control.
 *
 * CSS selector: `mobile/molecules.css` `.ds-qty-stepper`, with `.ds-qty-btn`,
 * `.ds-qty-value` and `.ds-qty-of`.
 *
 * Doctrine: both buttons are 44px, and a spent end goes flat desaturated grey
 * through the real `disabled` attribute rather than an opacity fade. Passing
 * the true attribute also stops keyboard and assistive-tech users activating a
 * control that cannot do anything.
 *
 * Controlled: pass `value` with `onDecrement` and `onIncrement`, and `min` and
 * `max` decide which end disables itself. `of` renders the trailing stock
 * caption inside the pill.
 */
export const QtyStepper = React.forwardRef(function QtyStepper(
  {
    className,
    value,
    min,
    max,
    onDecrement,
    onIncrement,
    of,
    decrementLabel = 'Decrease quantity',
    incrementLabel = 'Increase quantity',
    ...rest
  },
  ref,
) {
  const canDecrement = min === undefined || value > min;
  const canIncrement = max === undefined || value < max;

  return (
    <div ref={ref} className={cn('ds-qty-stepper', className)} {...rest}>
      <button
        type="button"
        className="ds-qty-btn"
        aria-label={decrementLabel}
        disabled={!canDecrement}
        onClick={onDecrement}
      >
        &minus;
      </button>
      <span className="ds-qty-value">{value}</span>
      <button
        type="button"
        className="ds-qty-btn"
        aria-label={incrementLabel}
        disabled={!canIncrement}
        onClick={onIncrement}
      >
        +
      </button>
      {of === undefined ? null : <span className="ds-qty-of">of {of}</span>}
    </div>
  );
});

export default QtyStepper;
